import { rtkApi as api } from '../rtkApi';

export interface PipelineStageProgress {
  percent: number;
  blockers: Array<{ kind: string; key: string; reason?: string }>;
  docsDone: number;
  docsTotal: number;
  catsDone: number;
  catsTotal: number;
}

export interface PipelineStage {
  key: string;
  label: string;
  requiredDocumentTypes: string[];
  requiredTaskCategories: string[];
  progress: PipelineStageProgress;
  isCurrent: boolean;
}

export interface ContractPipelineResponse {
  success: boolean;
  data: {
    contractId: string;
    currentStageKey: string;
    template: { id: string; name: string };
    stages: PipelineStage[];
  };
}

export const pipelineApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractPipeline: builder.query<ContractPipelineResponse, string>({
      query: (contractId) => ({
        url: `/pipeline/contract/${contractId}`,
        method: 'GET',
      }),
      providesTags: ['ContractPipeline'],
    }),

    ensureClosingTasks: builder.mutation<
      { success: boolean; created: number; data: any[] },
      string
    >({
      query: (contractId) => ({
        url: `/pipeline/contract/${contractId}/ensure-closing-tasks`,
        method: 'POST',
        data: {},
      }),
      invalidatesTags: ['ContractTasks', 'ContractPipeline'],
    }),

    ensurePostRatificationTasks: builder.mutation<
      { success: boolean; created: number; skipped?: boolean; data: any[] },
      string
    >({
      query: (contractId) => ({
        url: `/pipeline/contract/${contractId}/ensure-post-ratification-tasks`,
        method: 'POST',
        data: {},
      }),
      invalidatesTags: ['ContractTasks', 'ContractPipeline'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetContractPipelineQuery,
  useEnsureClosingTasksMutation,
  useEnsurePostRatificationTasksMutation,
} = pipelineApi;
